import { render, staticRenderFns } from "./TransferLoyaltyCard.vue?vue&type=template&id=13d062e0&scoped=true&"
import script from "./TransferLoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./TransferLoyaltyCard.vue?vue&type=script&lang=js&"
import style0 from "../../less/transfer.less?vue&type=style&index=0&id=13d062e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d062e0",
  null
  
)

export default component.exports